/* Toggle module. Used on footer & video page */
(function () {

    var el = $('.js-m-scroll-to');
    if (!el.length) return false;

    $('[data-scroll]').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var offset = 100;
        var target = ( '#' + $(this).data('scroll') );
        var $target = $(target);

        $target.velocity('scroll', {
            offset: -offset,
            duration: 1600,
            easing: "easeInBack"
        });
    });

})();